import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom'
import './index.css'

// Providers
import { AuthProvider } from './contexts/AuthContext'
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from './services/queryClient'
import { Provider } from "react-redux";
import { store } from './store'

// Layouts
import RootLayout from './components/layout/RootLayout'

// Pages
import ResourceManagementPage from './pages/ResourceManagementPage'
import CreateResourceRequestPage from './pages/CreateResourceRequestPage'
import ResourceRequestDetailPage from './pages/ResourceRequestDetailPage'
import ReportsPage from './pages/ReportsPage'
import NotFoundPage from './pages/NotFoundPage'
import LoginPage from './pages/LoginPage'
import GoogleCallbackPage from './pages/GoogleCallbackPage'
import TalentPoolPage from './pages/TalentPoolPage'
import PipelinePage from './pages/PipelinePage'
import UserManagementPage from './pages/UserManagementPage'

const router = createBrowserRouter([
  // Public routes
  {
    path: '/login',
    element: <LoginPage />
  },
  {
    path: '/auth/google/callback',
    element: <GoogleCallbackPage />
  },
  // Protected routes
  {
    path: '/',
    element: <RootLayout />, // RootLayout now handles authentication check
    errorElement: <NotFoundPage />,
    children: [
      {
        index: true,
        element: <Navigate to="/talent-pool" replace />
      },
      {
        path: 'resource-requests',
        element: <ResourceManagementPage />
      },
      {
        path: 'resource-requests/:id',
        element: <ResourceRequestDetailPage />
      },
      {
        path: 'resource-requests/create',
        element: <CreateResourceRequestPage />
      },
      {
        path: 'reports',
        element: <ReportsPage />
      },
      {
        path: 'talent-pool',
        element: <TalentPoolPage />
      },
      {
        path: 'pipeline',
        element: <PipelinePage />
      },
      {
        path: 'users',
        element: <UserManagementPage />
      }
    ]
  }
])

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <RouterProvider router={router} />
        </AuthProvider>
      </QueryClientProvider>
    </Provider>
  </StrictMode>,
)
